import React from "react";
import { Box, Typography, keyframes } from "@mui/material";
import { Check } from "lucide-react";

interface LoadingOverlayProps {
  show: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
        animation: `${fadeIn} 0.3s ease-out`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          animation: `${slideIn} 0.5s ease-out`,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: `${pulse} 2s infinite ease-in-out`,
            color: "white",
          }}
        >
          <Check size={40} />
        </Box>
        <Typography
          variant="h6"
          color="primary"
          sx={{
            animation: `${pulse} 2s infinite ease-in-out`,
            animationDelay: "0.3s",
          }}
        >
          Synkroniserar e-post
        </Typography>
      </Box>
    </Box>
  );
};
